export default __webpack_public_path__ + "static/media/Groupe 8825.ae74e035.svg";